import React, { Component } from 'react';
import SliderSlick from 'react-slick';
import Lightbox from 'react-image-lightbox';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';

class Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  render() {
    const { photos } = this.props;
    const { photoIndex, isOpen } = this.state;
    return (
      <div>
        <SliderSlick className="gallery" slidesToShow={3} dots>
          {photos.map(({ id, fluid: { src: photo } }, i) => (
            <div
              role="button"
              key={id}
              className="gallery-item"
              onClick={() => this.setState({ isOpen: true, photoIndex: i })}
            >
              <div className="gallery-preview">
                <LazyLoad>
                  <img src={photo} alt="img" className="gallery-img" />
                </LazyLoad>
              </div>
            </div>
          ))}
        </SliderSlick>
        {isOpen && (
          <Lightbox
            mainSrc={photos[photoIndex].file.url}
            nextSrc={photos[(photoIndex + 1) % photos.length].file.url}
            prevSrc={photos[(photoIndex + photos.length - 1) % photos.length].file.url}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() => this.setState({
              photoIndex: (photoIndex + photos.length - 1) % photos.length,
            })
            }
            onMoveNextRequest={() => this.setState({
              photoIndex: (photoIndex + 1) % photos.length,
            })
            }
          />
        )}
      </div>
    );
  }
}

Slider.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default Slider;
